import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, createElementBlock as _createElementBlock } from "vue"

import { InterviewQuestionResponseModel, Variant } from '@/models/QuestionModels'
import { computed, onMounted, ref } from 'vue'
import UploadMultipleFilesComponent from '@/components/InterviewQuestionary/Questions/UploadFilesQuestion/UploadMultipleFilesComponent.vue'
import RadioButtonQuestion from '@/components/InterviewQuestionary/Questions/RadioButtonQuestion.vue'
import FlatButton from '@/components/Shared/FlatButton.vue'
import { useInterviewStore } from '@/stores/interviewStore'
import { scrollToElementBottom } from '../../scrollToElementBottom'


export default /*#__PURE__*/_defineComponent({
  __name: 'UploadFilesQuestion',
  props: {
    question: null
  },
  setup(__props: any) {

const props = __props as { question: InterviewQuestionResponseModel };

const allowUploadMediaTypes = ['video/mp4', 'audio/mp3', 'audio/mpeg', 'image/gif', 'video/gif', 'image/jpg', 'image/jpeg', 'image/png', 'image/ico', 'image/x-icon', 'image/svg', 'image/svg+xml', 'application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/doc', 'application/docx']



const answer = ref<string | null>(null)
const isSubmited = ref<boolean>(false)
// check to false, exact false!
const showNextButton = computed(() => isUploadingImages.value === false && !isSubmited.value)

const interviewStore = useInterviewStore()
const nextBtnText = computed(() => interviewStore.getLocalization('InterviewQuestionary.Common.NextQuestionButton'))

const isUploadingImages = ref<boolean | null>(null)

const root = ref<HTMLElement | undefined>(undefined);
onMounted(() => scrollToElementBottom(root!.value as HTMLElement));

function onImageUploadDesireChoose(radioChoose: Variant) {
    isUploadingImages.value = radioChoose.Value === '0' || radioChoose.Value?.toLowerCase() === 'true' || radioChoose.Label === 'Yes' // TODO: hard logic (radio component can hold more than two answers on different languages)

    // if do not want to upload
    if (!isUploadingImages.value) {
        answer.value = radioChoose?.Label ?? ""
        interviewStore.changeAnswer(props.question.Id, answer.value);
    }
}

function submitDoNotWantYoUpload(){
    interviewStore.nextQuestion()
    isSubmited.value = true

}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "root",
    ref: root,
    class: "tw-question"
  }, [
    _createVNode(RadioButtonQuestion, {
      question: __props.question,
      isStandAlone: false,
      onHandleAnswerChoose: onImageUploadDesireChoose
    }, null, 8, ["question"]),
    (!!isUploadingImages.value)
      ? (_openBlock(), _createBlock(UploadMultipleFilesComponent, {
          key: 0,
          question: __props.question,
          supportedFileTypes: allowUploadMediaTypes,
          maxFileSizeBytes: _unref(interviewStore).maxFileSize
        }, null, 8, ["question", "maxFileSizeBytes"]))
      : _createCommentVNode("", true),
    (_unref(showNextButton))
      ? (_openBlock(), _createBlock(FlatButton, {
          key: 1,
          onClick: submitDoNotWantYoUpload,
          modelValue: _unref(nextBtnText),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(nextBtnText) ? (nextBtnText).value = $event : null)),
          bgColor: '#2C267A',
          isArrowStyle: true
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ], 512))
}
}

})